import React, { useEffect, useState } from "react";
import { GetRoles } from "../../../lib/data";
import AddEmployeesUi from "../../../ui/employeesUi/addEmployees";
import i18n from "../../../lib/i18n";

export default function AddEmployees () {

    const [rolesData, setrolesData] = useState([]);
    const t = i18n.t.bind(i18n); 
    
    useEffect(() => {
        handleApi();
    }, [])

    const handleApi = async () => {
        const rolesData = await GetRoles();
        setrolesData([]);
        rolesData.map((e) => setrolesData((prev) => [...prev, e]));
    };

    return(
        <div className="p-5 my-3 mx-6 rounded-lg bg-thirdly">
            <div>
                <h1 className="sm:text-[30px] text-[24px] text-center text-gray pt-1 sm:pb-8 pb-4">{t("add_page_title.employee")}</h1>
                <AddEmployeesUi rolesData={rolesData}/>
            </div>
        </div>
    );
};